import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: "Within 2 days of using Emily's sinus remedy, my congestion and headaches were gone. I've thrown out half the pills in my cabinet.",
    author: 'Sarah M.'
  }, {
    text: "My daughter's chronic gut issues finally improved. These remedies work better than anything we tried from the store.",
    author: 'Melissa K.'
  }, {
    text: "It's like having an herbalist in your pocket.",
    author: 'Early Reader'
  }];
  return <section className="w-full bg-emerald-50 py-16 md:py-24" data-id="element-544">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-545">
        <div className="flex items-center justify-center gap-3 mb-12" data-id="element-546">
          <StarIcon className="w-10 h-10 text-amber-500 fill-amber-500" data-id="element-547" />
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-548">
            Real Results
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-549">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-lg" data-id="element-550">
              <div className="flex gap-1 mb-4" data-id="element-551">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-552" />)}
              </div>
              <p className="text-stone-700 mb-4 leading-relaxed" data-id="element-553">
                "{testimonial.text}"
              </p>
              <p className="text-stone-900 font-semibold" data-id="element-554">
                – {testimonial.author}
              </p>
            </div>)}
        </div>
        <div className="text-center bg-white rounded-xl p-8 shadow-lg" data-id="element-555">
          <p className="text-xl text-stone-700 leading-relaxed" data-id="element-556">
            Over{' '}
            <span className="font-bold text-emerald-700" data-id="element-557">10,000 families</span>{' '}
            have already used Emily's natural remedies to support better sleep,
            stronger immunity, calmer digestion, and less pain — without relying
            on pharmaceuticals.
          </p>
        </div>
      </div>
    </section>;
}